import Swiper from 'swiper/bundle';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import iFrameResize from 'iframe-resizer';

function isMobile(){
  return (window.innerWidth <= 768);
}

// Shows the menus list & tasting menus list in gs-restaurants
function showMenusList() {
  let btnClicked;

  let btnMenus = document.getElementById('menu-btn-list');
  let listMenus = (document.getElementsByClassName('menus').length > 0) ? document.getElementsByClassName('menus')[0] : document.getElementsByClassName('menus');
  let btnTastingMenus = document.getElementById('tasting-menu-btn-list');
  let listTastingMenus = document.getElementsByClassName('tasting-menus')[0];


  if(this.id === "menu-btn-list"){
    btnClicked = "menus";
    if(listTastingMenus && listTastingMenus.classList !== undefined && listTastingMenus.classList.contains('visible')){
      listTastingMenus.classList.remove('visible');
    }
    if(btnTastingMenus) {
      btnTastingMenus.classList.remove('children-visible');
    }
  } else {
    btnClicked = "tasting-menus";
    if(listMenus.classList !== undefined && listMenus.classList.contains('visible')){
      listMenus.classList.remove('visible');
    }
    btnMenus.classList.remove('children-visible');
  }

  var listToShow = document.getElementsByClassName(btnClicked)[0];
  if(listToShow){
    if(!listToShow.classList.contains('visible')){
      listToShow.classList.add('visible');
    }else{
      listToShow.classList.remove('visible');
    }
  }

  if(!this.classList.contains('children-visible')){
    this.classList.add('children-visible');
    if(isMobile()){
      document.getElementsByClassName('gs-restaurant')[0].classList.add('visible');
    }
  }else{
    this.classList.remove('children-visible');
    if(isMobile()){
      document.getElementsByClassName('gs-restaurant')[0].classList.remove('visible');
    }
  }
}

/**
 * Returns if the current hour:minute is between startTime and endTime
 *
 * @param {string} startTime
 * @param {string} endTime
 * @returns
 */
function isTimeInRange(startTime, endTime) {
  const urlParams = new URLSearchParams(window.location.search);
  const debugDay = urlParams.get('debugDay'); // Set ?debugDay=YYYY-MM-DDTHH:II:SS
  const now = debugDay !== null ? new Date(debugDay) : new Date();

  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  const startParts = startTime.split(":");
  const startHour = parseInt(startParts[0]);
  const startMinute = parseInt(startParts[1]);

  const endParts = endTime.split(":");
  const endHour = parseInt(endParts[0]);
  const endMinute = parseInt(endParts[1]);

  if (startHour < endHour) {
    return (currentHour > startHour || (currentHour === startHour && currentMinutes >= startMinute)) &&
           (currentHour < endHour || (currentHour === endHour && currentMinutes < endMinute));
  } else if (startHour > endHour) {
    return (currentHour > startHour || (currentHour === startHour && currentMinutes >= startMinute)) ||
           (currentHour < endHour || (currentHour === endHour && currentMinutes < endMinute));
  } else {
    return currentHour === startHour && currentMinutes >= startMinute &&
           currentHour === endHour && currentMinutes < endMinute;
  }
}

/**
 *
 * Returns the current day time service.
 * It's possible to have more than one time service at the same time.
 *
 * @returns array
 */
function getDayTimeList() {

  const dayTime =  new Array();

  if( isTimeInRange('09:00', '12:00') ) { dayTime.push('breakfast') }
  if( isTimeInRange('10:00', '17:30') ) { dayTime.push('lunch') }
  if( isTimeInRange('17:00', '19:00') ) { dayTime.push('snack') }
  if( isTimeInRange('18:00', '01:00') ) { dayTime.push('dinner') }

  return dayTime;
}

function getShortDayName(date) {
  const daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  return daysOfWeek[date.getDay()];
}

function isTodayHoliday(holidays) {
  const urlParams = new URLSearchParams(window.location.search);
  const debugDay = urlParams.get('debugDay'); // Set ?debugDay=YYYY-MM-DD
  const today = debugDay !== null ? new Date(debugDay) : new Date();

  // Set the current date to midnight
  today.setHours(0, 0, 0, 0);

  // Check if today is a holiday
  for (let index = 0; index < holidays.length; index++) {
    const day = holidays[index];
    const date = new Date(day);

    // Set the given date to midnight
    date.setHours(0, 0, 0, 0);

    // Today is holiday
    if (today.toDateString() === date.toDateString()) {
      return true;
    }
  }

  return false;
}

function isTodayPreHoliday(holidays) {
  const urlParams = new URLSearchParams(window.location.search);
  const debugDay = urlParams.get('debugDay'); // Set ?debugDay=YYYY-MM-DD
  const today = debugDay !== null ? new Date(debugDay) : new Date();

  // Set the current date to midnight
  today.setHours(0, 0, 0, 0);

  // Check if today is a holiday
  for (let index = 0; index < holidays.length; index++) {
    const day = holidays[index];
    const date = new Date(day);

    // Set the given date to midnight
    date.setHours(0, 0, 0, 0);

    const compareDate = new Date(date.getTime() - (60 * 60 * 1000) ); // Subtract 1h to date to get the previous day
    const compareString = compareDate.toDateString();
    const todayString = today.toDateString();
    // Check if today is the previous day to a holiday
    if (todayString === compareString) {
      return true;
    }
  }

  return false;
}

function getCurrentDay( ) {
  // const today = new Date("2023-10-25"); // Debug line. Set the hour we want
  const urlParams = new URLSearchParams(window.location.search);
  const debugDay = urlParams.get('debugDay'); // Set ?debugDay=YYYY-MM-DD
  const today = debugDay !== null ? new Date(debugDay) : new Date();
  // const today = new Date();

  // Set the current date to midnight
  today.setHours(0, 0, 0, 0);

  return getShortDayName(today);
}

$(() => {
  // Menu selector Toggles
  var btnMenusList = document.getElementById("menu-btn-list");
  var btnTastingMenusList = document.getElementById("tasting-menu-btn-list");

  if( btnMenusList ) {
    btnMenusList.addEventListener('click', showMenusList, false);
  }

  if( btnTastingMenusList ) {
    btnTastingMenusList.addEventListener('click', showMenusList, false);
  }

  // Scheduled Menus
  const restaurant = document.querySelector('article.gs-restaurant');
  if(restaurant !== null && restaurant.classList.contains('scheduled-menus') && restaurant.classList.contains('qrcode')) {

    // Menu selection by time and currentDay.
    const dayTimeList = getDayTimeList();
    const holidays = restaurant.hasAttribute('data-holidays') ? restaurant.dataset.holidays : '';
    const currentDay = getCurrentDay();
    let isHoliday = false;
    let isPreHoliday = false;
    if( holidays !== '' ) {
      let holidaysList = holidays.split(',');
      isHoliday = isTodayHoliday(holidaysList);
      isPreHoliday = isTodayPreHoliday(holidaysList);
    }

    if( dayTimeList.length > 0 || currentDay !== '' ) {
      const menus = document.querySelectorAll('.menu-selector');
      menus.forEach((menu) => {
        const menuItems = menu.querySelectorAll('.menu-selector__item');
        const totalItems = menuItems.length;
        if(totalItems > 0) {
          let hiddenItems = 0;
          for (let index = 0; index < menuItems.length; index++) {
            const menuItem = menuItems[index];

            // Hide items that are not in the selected time of the day
            let hideItem = true;
            for (let index = 0; index < dayTimeList.length; index++) {
              const dayTime = dayTimeList[index];

              if( menuItem.hasAttribute('data-time') && menuItem.dataset.time.includes(dayTime) ) {
                hideItem = false;
                break;
              }
            }

            if(hideItem) {
              menuItem.style.display = 'none';
              hiddenItems++;

              continue;
            }

            // If current day is previous to a holiday (pre) and we are at the dinner time hide the menu if it has not the proper configuration
            if( dayTimeList.includes('dinner') && isPreHoliday ) {
              if( menuItem.hasAttribute('data-time') && menuItem.dataset.time.includes('dinner') ) {
                if( menuItem.hasAttribute('data-week') && ! menuItem.dataset.week.includes('pre') ) {
                  menuItem.style.display = 'none';
                  hiddenItems++;
                }
                continue;
              }
            }

            // If current day is a holiday (hol) and we are at the lunch time hide the menu if it has not the proper configuration
            if( dayTimeList.includes('lunch') && isHoliday ) {
              if( menuItem.hasAttribute('data-time') && menuItem.dataset.time.includes('lunch') ) {
                if( menuItem.hasAttribute('data-week') && ! menuItem.dataset.week.includes('hol') ) {
                  menuItem.style.display = 'none';
                  hiddenItems++;
                }
                continue;
              }
            }

            // Check current day of the week
            if( menuItem.hasAttribute('data-week') && ! menuItem.dataset.week.includes(currentDay) ) {
              menuItem.style.display = 'none';
              hiddenItems++;
              continue;
            }
          }

          if( hiddenItems === totalItems ) {
            menu.closest('.gallery__menu').style.display = 'none';
          }
        }
      });
    }

    // Debug information for scheduled menus
    // www.gruposaona.test/restaurante/saona-alameda/?qrcode&debugInfo&debugDay=2023-11-01T17:10
    const urlParams = new URLSearchParams(window.location.search);
    const debugInfo = urlParams.get('debugInfo'); // Set ?debugDay=YYYY-MM-DD
    if( debugInfo !== null ) {
      const urlParams = new URLSearchParams(window.location.search);
      const debugDay = urlParams.get('debugDay'); // Set ?debugDay=YYYY-MM-DD
      const today = debugDay !== null ? new Date(debugDay) : new Date();

      var debugLayer = document.createElement("div");
      debugLayer.style.width = "100%";
      debugLayer.style.background = "red";
      debugLayer.style.padding = "10px";
      debugLayer.style.color = "white";
      debugLayer.style.wordBreak = "break-word";
      debugLayer.innerHTML = `
        Today: ${today}<br>
        Daytime: ${dayTimeList.map(tag => `<span>${tag}</span>`).join(',')}<br>
        Holidays: ${holidays}<br>
        currentDay: ${currentDay}<br>
        isHoliday: ${isHoliday}<br>
        isPreHoliday: ${isPreHoliday}<br>
      `;

      document.querySelector('article.gs-restaurant header').appendChild(debugLayer);
    }
  }
});


// Initialize swiper image-slider
window.addEventListener('load', ()=>{
  if ($('.gallery').length > 0) {
    new Swiper('.image-slider-container', {
      loop: true,
      effect: 'slide',
      grabCursor: true,
      direction: 'horizontal',
      centeredSlides: false,
      slidesPerView: 1,
      pagination: {
        el: '.image-slider-pagination',
        type: 'bullets',
        dynamicBullets: true,
        renderBullet: function (index, className) {
          return `<span class="${className}">${(index + 1)}</span>`;
        },
        dynamicMainBullets: 4,
        currentClass: 'current',
        parallax: true,
      },
      navigation: {
        nextEl: '.image-slider-button-next',
        prevEl: '.image-slider-button-prev',
      },
    });
  }


  // Function to set the full height for an iframe
  if(document.getElementById('reservar')){

    const resizeIframe = () => {
      const iframe = window.parent.document.querySelector('.iframe-covermanager');
      if(iframe){
        iframe.style.height = '100%';
      }
    }

    resizeIframe();

    iFrameResize.iframeResizer({},'.iframe-covermanager');
  }

  let singleRestaurantBody = document.querySelector('.single-gs-restaurant');
  if(singleRestaurantBody){
    let menuBtnList = document.getElementById('menu-btn-list');
    let tastingMenuBtnList = document.getElementById('tasting-menu-btn-list');
    let urlParameters = new URLSearchParams(window.location.search);

    if(urlParameters.get('show-menu') === "main-menu"){
      menuBtnList.classList.add('children-visible');
      menuBtnList.nextElementSibling.classList.add('visible');
      if(isMobile()){
        document.getElementsByClassName('gs-restaurant')[0].classList.add('visible');
      }
    }

    if(urlParameters.get('show-menu') === "special-menu"){
      tastingMenuBtnList.classList.add('children-visible');
      tastingMenuBtnList.nextElementSibling.classList.add('visible');
      if(isMobile()){
        document.getElementsByClassName('gs-restaurant')[0].classList.add('visible');
      }
    }
  }

});

// Hide booking button when scroll arrives to booking iframe
let iframeReserva = document.querySelector('#reservar');
if( iframeReserva ){
  ScrollTrigger.create({
    trigger: "#sticky-header",
    endTrigger: iframeReserva,
    start: "top -10%",
    end: "bottom: 70%",
    toggleClass: {
      targets: ".booking-button",
      className: "visible",
    },
  });
}


